export const windChimeStrings = {
    start: 'Start wind chimes',
    mute: 'Mute wind chimes',
    unmute: 'Unmute wind chimes',
    resume: 'Resume wind chimes',
    volume: 'Wind chime volume',
    volumeLevel: (percentage: number) => `${percentage}% of full chime volume`,
    mutedStatus: 'Wind chimes are muted.',
    startingStatus: 'Starting wind chimes.',
    playingStatus: 'Wind chimes are playing.',
    pausedStatus: 'Wind chimes are paused. Activate the sound button to resume.',
    errorStatus: 'Wind chimes could not start. Activate the sound button to try again.'
} as const;
